module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/nature.07eedf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/nature.jpg
// module id = IjUu
// module chunks = 0